import { WSLoader } from "@wingspanhq/fe-component-library";
import React, { useMemo } from "react";
import { Redirect } from "react-router-dom";
import { queriesStakeholders } from "@query";
import { useSession } from "@hooks/useSession";
import { FormStakeholder } from "../components/FormStakeholder";
import { Layout } from "../../../shared/components/Layout";
import {
  routeHelpersAccountStakeholders,
  routeHelpersAccountStakeholdersEdit
} from "../paths";

export const RouteEditStakeholder: React.FC = () => {
  const { accountId } = useSession();
  const { params } = routeHelpersAccountStakeholdersEdit.useData();
  const stakeholderId = params.stakeholderId;

  const goToList = routeHelpersAccountStakeholders.useGoTo();

  const queryStakeholder = queriesStakeholders.getStakeholder.useQuery(
    { accountId, stakeholderId },
    { enabled: !!accountId && !!stakeholderId }
  );

  const [updateStakeholder, updateStakeholderMeta] =
    queriesStakeholders.updateStakeholder.useMutation();

  const goBack = useMemo(() => () => goToList(), [goToList]);

  const stakeholder = queryStakeholder.data;

  return (
    <Layout title="Edit team member" onBack={goBack} onClose={goBack}>
      {queryStakeholder.isLoading ? (
        <WSLoader.Spinner />
      ) : !stakeholder ? (
        <Redirect to={routeHelpersAccountStakeholders.path} />
      ) : (
        <FormStakeholder
          isEdit
          title="Edit team member"
          submitButtonLabel="Update member"
          loading={updateStakeholderMeta.isLoading}
          error={updateStakeholderMeta.error}
          onBack={goBack}
          onSubmit={async data => {
            await updateStakeholder(
              {
                accountId,
                stakeholderId,
                stakeholderUpdate: {
                  roleId: data.roleId
                }
              },
              { throwOnError: true }
            );

            goBack();
          }}
          defaultValues={{
            email: stakeholder.email || "",
            roleId: stakeholder.roleId || ""
          }}
        />
      )}
    </Layout>
  );
};
